import { useGontijoSessionContext } from 'context/GontijoSession';

/**
 * The single read point for the Gontijo client session in components.
 *
 * Nothing else should reach for the session: not `localStorage`, not the Redux slice, not the
 * storage module. One reader is what keeps "is this buyer signed in?" from being answered three
 * slightly different ways on three screens — and it is where the expiry buffer gets applied for
 * everyone, rather than at whichever call sites happened to remember it.
 *
 * Outside a component — in a payload builder, say — the equivalent is
 * `selectGontijoClientAuth(state)`.
 * @returns {{enabled: boolean, token: ?string, expiresAt: ?number, email: ?string, isAuthenticated: boolean, isHydrated: boolean, isValidating: boolean, establish: Function, signOut: Function, revalidate: Function}} The session.
 */
const useGontijoSession = () => useGontijoSessionContext();

export default useGontijoSession;
